<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.meta.breadcrumbTitle">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-dropdown menu-on-right
                     class="btn-neutral btn-sm"
                     tag="base-button"
                     title-tag="span"
                     title="Options"
                     menuClasses="">

        <template>
          <b-dropdown-item @click="onDelete">
            <i class="ni ni-fat-remove"></i>
            <span>Delete</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Maintenance details</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <b-form @submit.prevent="updateItem">
          <b-row>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="motorbike">Motorbike</label>
                <select class="form-control" v-model="model.motorbike">
                  <option v-for="motorbike in motorbikes" v-bind:key="motorbike.id" v-bind:value="motorbike.id">{{motorbike._name}}</option>
                </select>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="date">Date</label>
                <base-input type="date" id="date" placeholder="Date" v-model="model._date" @change="dateChanged"/>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="mileage">Mileage</label>
                <input type="number" class="form-control" id="mileage" placeholder="Mileage" v-model.number="model.km">
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="concept">Concept</label>
                <autocomplete :url="conceptsUrl"
                  anchor="name"
                  label=""
                  param="s"
                  ref="concept"
                  id="concept"
                  placeholder="Concept"
                  :classes="{input:  'form-control'}"
                  :customHeaders="{ Authorization: authToken }"
                  :on-select="selectConcept">
                </autocomplete>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="description">Description</label>
                <input type="text" class="form-control" id="description" placeholder="Description" v-model="model.description">
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="price">Price</label>
                <input type="number"  step="any" class="form-control" id="price" placeholder="Price" v-model.number="model.price">
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="garage">Garage</label>
                <input type="text" class="form-control" id="garage" placeholder="Garage" v-model.number="model.garage">
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
            </b-col>
          </b-row>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import Autocomplete from 'vue2-autocomplete-js'
  import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css'
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import { mapActions, mapGetters } from 'vuex';
  import conceptsAPI from '../../api/maintenanceConcepts'

  export default {
    name: 'starter-page',
    components: {
      Autocomplete,
      RouteBreadCrumb
    },
    data() {
      return {
        model: {},
        authToken: `Bearer ${JSON.parse(localStorage.getItem('user')).token}`,
        conceptsUrl: conceptsAPI.url
      };
    },
    async mounted() {
      await this.getItem(this.$route.params.id)
      await this.listMotorbikes()
      this.model = {
        motorbike: this.item.motorbike && this.item.motorbike._id || this.item.motorbike,
        date: this.item.date,
        _date: this.item.date && new Date(this.item.date).toInputDateFormat(),
        km: this.item.km,
        concept: this.item.concept,
        description: this.item.description,
        price: this.item.price,
        garage: this.item.garage,
      }
      this.$route.meta.breadcrumbTitle = this.model._date
      if (this.model.concept && this.model.concept.name) {
        this.$refs.concept.setValue(this.model.concept.name)
      }
    },
    methods: {
      ...mapActions({
        listMotorbikes: 'motorbikes/fetch',
        getItem: 'maintenances/show',
        editItem: 'maintenances/edit',
        deleteItem: 'maintenances/delete'
      }),
      async updateItem() {
        await this.editItem({ id: this.$route.params.id, data: this.model })
      },
      onDelete() {
        this.deleteItem(this.$route.params.id)
        this.$router.push({ name: 'maintenances' })
      },
      dateChanged() {
        this.model.date = this.model._date && this.model._date.fromInputDateFormatToDate().toISOString()
      },
      selectConcept(concept) {
        this.model.concept = concept
      }
    },
    computed: {
      ...mapGetters({
        concepts: 'maintenanceConcepts/items',
        item: 'maintenances/item',
        motorbikes: 'motorbikes/motorbikes'
      }),
      hasChanges () {
        let changes = 0
        const keys = [
          'motorbike',
          'date',
          'km',
          'concept',
          'description',
          'price',
          'garage'
        ]
        Object.keys(this.model).filter(k => keys.indexOf(k) > -1).forEach(key => {
          if ((this.item[key] && this.item[key]._id || this.item[key]) !== (this.model[key] && this.model[key]._id || this.model[key])) {
            changes++
          }
        })
        return !!(changes)
      }
    }
  };
</script>
<style scoped>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .dropdown {
    z-index: 1000;
  }
</style>
